<template>
  <v-expansion-panels>
    <v-expansion-panel title="Filter Options">
      <v-expansion-panel-text>
        <form v-no-autofill @submit.prevent="refresh">
          <v-row v-for="(row, rowIndex) in rowData" :key="rowIndex" no-gutters>
            <v-col
              v-for="field in row"
              :key="field.propertyName"
              :cols="12 / fieldsPerRow.base"
              :md="12 / fieldsPerRow.md"
              :lg="12 / fieldsPerRow.lg"
              class="pa-2"
            >
              <v-date-input
                v-if="
                  field.propertyType == MetaTypesBase.Date ||
                  field.propertyType == MetaTypesBase.LocalDate
                "
                :label="lowerCamelToTitle(field.propertyName)"
                v-model="table.filter.value[field.propertyName]"
                :clearable="!field.required"
              />
              <EnumSelect
                v-else-if="field.propertyType.isEnum"
                :label="lowerCamelToTitle(field.propertyName)"
                v-model="table.filter.value[field.propertyName]"
                :enum-object="field.propertyType.enum"
                :multiple="field.isArray"
                :clearable="!field.required"
              />
              <v-select
                v-else-if="field.propertyType == MetaTypesBase.boolean"
                :label="lowerCamelToTitle(field.propertyName)"
                v-model="table.filter.value[field.propertyName]"
                :items="booleanFilterItems"
                item-title="title"
                item-value="value"
                clearable
              />
              <v-text-field
                v-else-if="field.propertyType == MetaTypesBase.string"
                :label="lowerCamelToTitle(field.propertyName)"
                v-model="table.filter.value[field.propertyName]"
                :clearable="!field.required"
              />
              <v-text-field
                v-else-if="field.propertyType == MetaTypesBase.number"
                type="number"
                :label="lowerCamelToTitle(field.propertyName)"
                v-model.number="table.filter.value[field.propertyName]"
                :clearable="!field.required"
              />
              <CurrencyInput
                v-else-if="field.propertyType == MetaTypesBase.currency"
                :label="lowerCamelToTitle(field.propertyName)"
                :amount-cents="table.filter.value[field.propertyName]"
                :clearable="!field.required"
                allow-negative
                @update:amount-cents="
                  (value) => setFilterValue(field.propertyName, value)
                "
              />
              <p v-else>UNKNOWN {{ field.propertyName }}</p>
            </v-col>
          </v-row>
          <v-expansion-panels
            v-if="advancedRowData.length"
            class="mb-4"
            variant="accordion"
          >
            <v-expansion-panel title="Additional Filter Options">
              <v-expansion-panel-text>
                <v-row
                  v-for="(row, rowIndex) in advancedRowData"
                  :key="rowIndex"
                  no-gutters
                >
                  <v-col
                    v-for="field in row"
                    :key="field.propertyName"
                    :cols="12 / fieldsPerRow.base"
                    :md="12 / fieldsPerRow.md"
                    :lg="12 / fieldsPerRow.lg"
                    class="pa-2"
                  >
                    <v-date-input
                      v-if="
                        field.propertyType == MetaTypesBase.Date ||
                        field.propertyType == MetaTypesBase.LocalDate
                      "
                      :label="lowerCamelToTitle(field.propertyName)"
                      v-model="table.filter.value[field.propertyName]"
                      :clearable="!field.required"
                    />
                    <EnumSelect
                      v-else-if="field.propertyType.isEnum"
                      :label="lowerCamelToTitle(field.propertyName)"
                      v-model="table.filter.value[field.propertyName]"
                      :enum-object="field.propertyType.enum"
                      :multiple="field.isArray"
                      :clearable="!field.required"
                    />
                    <v-select
                      v-else-if="field.propertyType == MetaTypesBase.boolean"
                      :label="lowerCamelToTitle(field.propertyName)"
                      v-model="table.filter.value[field.propertyName]"
                      :items="booleanFilterItems"
                      item-title="title"
                      item-value="value"
                      clearable
                    />
                    <v-text-field
                      v-else-if="field.propertyType == MetaTypesBase.string"
                      :label="lowerCamelToTitle(field.propertyName)"
                      v-model="table.filter.value[field.propertyName]"
                      :clearable="!field.required"
                    />
                    <v-text-field
                      v-else-if="field.propertyType == MetaTypesBase.number"
                      type="number"
                      :label="lowerCamelToTitle(field.propertyName)"
                      v-model.number="table.filter.value[field.propertyName]"
                      :clearable="!field.required"
                    />
                    <CurrencyInput
                      v-else-if="field.propertyType == MetaTypesBase.currency"
                      :label="lowerCamelToTitle(field.propertyName)"
                      :amount-cents="table.filter.value[field.propertyName]"
                      :clearable="!field.required"
                      allow-negative
                      @update:amount-cents="
                        (value) => setFilterValue(field.propertyName, value)
                      "
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row no-gutters>
            <v-col cols="12" lg="12" class="pa-2">
              <v-select
                v-model="table.visibleHeaders.value"
                label="Fields"
                item-title="title"
                item-value="key"
                :items="table.headersRaw.value"
                multiple
              >
              </v-select>
            </v-col>
            <v-col
              v-if="!hideExport"
              cols="12"
              lg="6"
              class="pa-2 d-flex flex-wrap ga-2"
            >
              <v-btn
                append-icon="mdi-download"
                :disabled="!!table.isLoading.value || table.isExporting.value"
                @click="exportCSV(undefined, 'page')"
              >
                Export page
              </v-btn>
              <v-btn
                append-icon="mdi-download"
                :disabled="!!table.isLoading.value || table.isExporting.value"
                @click="exportCSV(undefined, 'full')"
              >
                Export full
              </v-btn>
              <v-btn
                v-for="id in exportIds"
                :key="id"
                append-icon="mdi-download"
                :disabled="!!table.isLoading.value || table.isExporting.value"
                @click="exportCSV(id)"
              >
                Export {{ id }}
              </v-btn>
            </v-col>
            <v-col cols="12" :lg="hideExport ? 12 : 6" class="pa-2">
              <v-btn
                block
                append-icon="mdi-refresh"
                class="bg-primary"
                type="submit"
                :disabled="applyDisabled"
              >
                Apply Filter
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script
  lang="ts"
  setup
  generic="
    T_Item extends Record<string, any>,
    T_Filter extends FilterBase,
    T_Meta extends MetaType<TypeDefineType>
  "
>
import { lowerCamelToTitle } from "@/api/util";
import {
  MetaType,
  MetaTypesBase,
  PropertyMeta,
  TypeDefineType,
} from "@/autogen/common";
import { FilterBase, TableHelperType } from "@/composables/useTableHelper";
function chunkArray<T>(array: T[], chunkSize: number): T[][] {
  if (chunkSize <= 0) {
    throw new Error("chunkSize must be greater than 0");
  }

  const result: T[][] = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }

  return result;
}
const defaultFieldsPerRow = {
  base: 1,
  md: 2,
  lg: 4,
};
const booleanFilterItems = [
  { title: "Yes", value: true },
  { title: "No", value: false },
];
const props = defineProps<{
  table: TableHelperType<T_Item, T_Filter, T_Meta>;
  filterMeta: Record<string, PropertyMeta<any>>;
  advancedFilterMeta?: Record<string, PropertyMeta<any>>;
  fieldsPerRow?: {
    base: number;
    md: number;
    lg: number;
  };
  exportIds?: string[];
  applyDisabled?: boolean;
  hideExport?: boolean;
}>();

const filterMetaValues = computed(() => Object.values(props.filterMeta));
const advancedFilterMetaValues = computed(() =>
  Object.values(props.advancedFilterMeta || {}),
);

const fieldsPerRow = computed(() => props.fieldsPerRow || defaultFieldsPerRow);

const rowData = computed(() =>
  chunkArray(filterMetaValues.value, fieldsPerRow.value.lg),
);
const advancedRowData = computed(() =>
  chunkArray(advancedFilterMetaValues.value, fieldsPerRow.value.lg),
);

function setFilterValue(name: string, value: unknown) {
  (props.table.filter.value as Record<string, unknown>)[name] = value ?? null;
}

function refresh() {
  if (props.applyDisabled) return;
  // A new filter can easily have fewer matching pages than whatever page the user was
  // previously on - always land back on page 1 so `reloadItems()` doesn't request an
  // out-of-range page (server-paginated tables would just come back empty). Only call
  // `reloadItems()` explicitly when the page was already 1, since otherwise setting
  // `pagination.value.page = 1` itself already triggers a reload via `useTableHelper`'s
  // own `watch(pagination, ...)` - calling both would double-fetch.
  const pagination = props.table.pagination;
  if (pagination && pagination.value.page !== 1) {
    pagination.value.page = 1;
  } else {
    props.table.reloadItems();
  }
}

function exportCSV(id?: string, scope: "page" | "full" = "full") {
  void props.table.saveCSVFile(id, scope);
}
</script>
